import React from 'react';
import { Card } from 'react-bootstrap'

export default class QuestionTpl extends React.Component {
    render() {
        const { index, title, description, component: Component, fineprint, componentProps } = this.props;

        return (
            <Card className="question">
                <Card.Title>{/*<span className="index">{index}.</span>*/} {title}</Card.Title>
                <Card.Body>
                    <div className="description">{description}</div>
                    <Component {...componentProps} />
                    <div className="fineprint">{fineprint}</div>
                </Card.Body>
                
            </Card>

        );
    }
}
